import { useEffect } from 'react';
import MouseFlow from '@/utils/mouse-flow';

const useMouseFlow = () => {
  const popstateHandler = (pageName: string): VoidFunction => {
    return (): void => MouseFlow.push(pageName, location.pathname);
  };

  const initMouseFlow = (): void => {
    MouseFlow.init();
    MouseFlow.push('newPageView', '/app');
  };

  useEffect(() => {
    initMouseFlow();
    window.addEventListener('popstate', popstateHandler('newPageView'));
    return () => {
      window.removeEventListener('popstate', popstateHandler('newPageView'));
    };
  }, []);
};

export default useMouseFlow;
